<template>
  <div id="app">
    <el-container>
      <el-header class="static-header">
        <y-header></y-header>
      </el-header>

      <el-main>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>

      <el-footer style="height: 36px">
        <y-footer></y-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  import YHeader from '@/components/y-header/y-header'
  import YFooter from '@/components/y-footer/y-footer'

  export default {
    name: 'app',
    components: {
      YHeader,
      YFooter
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  html, body {
    padding: 0;
    margin: 0;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }

  .el-header, .el-main, .el-footer {
    padding: 0px !important;
  }

  .static-header {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue